import React from 'react';
import { NavBar, List, Button, Switch } from 'antd-mobile';
import { CheckCircleFill } from 'antd-mobile-icons';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SCAN_SOUND_OPTIONS } from '../../utils/pda/scanSoundOptions';
import { useScanSoundSettingsStore } from '../../store/scanSoundSettingsStore';
import { playEnqueuedScanSound } from '../../utils/pda/scanSoundUtils';

const PdaScanSettingPage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const {
    masterEnabled,
    vibrateEnabled,
    soundEnabled,
    selectedSoundId,
    setSelectedSoundId,
    updateSetting,
  } = useScanSoundSettingsStore();

  const soundOptions = SCAN_SOUND_OPTIONS;

  const handleSelect = (id: string) => {
    setSelectedSoundId(id);
    void playEnqueuedScanSound(id).catch(() => {});
  };

  const handlePreview = (e: React.MouseEvent, id: string) => {
    e.stopPropagation();
    void playEnqueuedScanSound(id).catch(() => {});
  };

  return (
    <div className="flex flex-col h-screen bg-white">
      <NavBar onBack={() => navigate('/pda/home')}>
        {t('pda.scanSetting.title')}
      </NavBar>

      <List>
        <List.Item extra={<Switch checked={masterEnabled} onChange={(v) => updateSetting({ masterEnabled: v })} />}>
          {t('pda.scanSetting.master')}
        </List.Item>
        <List.Item extra={<Switch checked={vibrateEnabled} disabled={!masterEnabled} onChange={(v) => updateSetting({ vibrateEnabled: v })} />}>
          <span className={masterEnabled ? '' : 'text-gray-400'}>{t('pda.scanSetting.vibrate')}</span>
        </List.Item>
        {/* todo <sunruixin>: 呼吸灯硬件接通后恢复 UI（store/bridge/DB 字段全保留） */}
        <List.Item extra={<Switch checked={soundEnabled} disabled={!masterEnabled} onChange={(v) => updateSetting({ soundEnabled: v })} />}>
          <span className={masterEnabled ? '' : 'text-gray-400'}>{t('pda.scanSetting.sound')}</span>
        </List.Item>
      </List>

      {masterEnabled && soundEnabled && (
        <List className="mt-2 flex-1 overflow-auto" header={t('pda.scanSetting.soundList')}>
          {soundOptions.map(option => (
            <List.Item
              key={option.id}
              extra={
                <div className="flex items-center gap-2">
                  <Button
                    size="mini"
                    fill="none"
                    onClick={(e) => handlePreview(e, option.id)}
                  >
                    {t('pda.scanSetting.preview')}
                  </Button>
                  {selectedSoundId === option.id && (
                    <CheckCircleFill color="#00b578" />
                  )}
                </div>
              }
              onClick={() => handleSelect(option.id)}
              arrowIcon={false}
            >
              {t(option.labelKey)}
            </List.Item>
          ))}
        </List>
      )}
    </div>
  );
};

export default PdaScanSettingPage;
